export var SeatingType = /*#__PURE__*/function (SeatingType) {
  SeatingType["Section"] = "section";
  SeatingType["Row"] = "row";
  return SeatingType;
}({});